import { SectionHeader } from './SectionHeader'
import { TransposedDataGrid } from './TransposedDataGrid'
import type { CostMetricsItem } from '@/entities/dailyMetric'

interface CostMetricsTableProps {
  costMetrics: CostMetricsItem[]
}

export function CostMetricsTable({ costMetrics }: CostMetricsTableProps) {
  // Define metric types for the table
  const metricTypes = [
    { field: 'Minutes', headerName: 'Minutes' },
    { field: 'Cost', headerName: 'Cost ($)' },
    { field: 'Rate', headerName: 'Price Rate ($/min)' },
  ]

  // Create rows for each metric type
  const rows = metricTypes.map((metricType, index) => {
    const row: Record<string, string | number> = {
      id: index,
      metric: metricType.headerName,
    }

    // Add data for each date and calculate totals
    let sumValue = 0
    costMetrics.forEach((metric) => {
      let value = metric[metricType.field as keyof CostMetricsItem] as number
      if (metricType.field === 'Cost') {
        sumValue += value
        row[metric.date] = value > 0 ? value.toFixed(1) : ''
      } else if (metricType.field === 'Rate') {
        sumValue += value
        row[metric.date] = value > 0 ? value.toFixed(4) : ''
      } else if (metricType.field === 'Minutes') {
        sumValue += value
        row[metric.date] = value > 0 ? value : ''
      }
    })

    // Calculate total based on metric type
    if (metricType.field === 'Rate') {
      // Rate = total cost / total minutes
      const totalCost = costMetrics.reduce((acc, m) => acc + (m.Cost || 0), 0)
      const totalMinutes = costMetrics.reduce((acc, m) => acc + (m.Minutes || 0), 0)
      const rateValue = totalMinutes > 0 ? totalCost / totalMinutes : 0
      row.total = rateValue > 0 ? rateValue.toFixed(4) : ''
    } else if (metricType.field === 'Cost') {
      row.total = sumValue > 0 ? sumValue.toFixed(1) : ''
    } else {
      row.total = sumValue > 0 ? sumValue : ''
    }

    return row
  })

  return (
    <div className="flex flex-col w-full mt-8">
      <SectionHeader title="Cost Metrics" />
      <div className="bg-white rounded-lg shadow-sm border border overflow-hidden">
        <TransposedDataGrid
          rows={rows}
          firstColumn={{
            field: 'metric',
            headerName: 'Metric',
          }}
          lastColumn={{
            field: 'total',
            headerName: 'Total',
            type: 'number' as const,
          }}
          dates={costMetrics.map((metric) => metric.date)}
        />
      </div>
    </div>
  )
}